import React, { useEffect } from "react";
import {
  Modal,
  Form,
  Input,
  Checkbox,
  Upload,
  TreeSelect,
  Spin,
  Select,
  Row,
  Col,
  notification,
  Radio,
  InputNumber,
  DatePicker,
} from "antd";
import { observer } from "mobx-react";
import { Storage } from "@aws-amplify/storage";
import { v4 } from "uuid";
import { formatBytes } from "../../../common/Utils";
import { volunteersStore } from "../../../store/volunteer/VolunteersStore";
import { ListInput } from "../../../components/ListInput";
import { VolunteerOptions } from "./VolunteerOptions";
import { MultipleDatePicker } from "../../../components/MultipleDatePicker";
import { GooglePlacePicker } from "../../../components/GooglePlacePicker";
import { isEmail } from "validator";

const Categories = [
  "Serve Elderly",
  "Arts & Crafts",
  "Music",
  "Cooking",
  "Environmental",
  "Love Animals",
  "Board Games",
  "Sports Stretch",
  "Gardening",
  "Food Bank",
  "Clean River",
  "Vines",
  "Team",
];

export const VolunteerDlg = observer(() => {
  const [form] = Form.useForm();

  const store = volunteersStore;

  useEffect(() => {
    store.editStore.loadRegions();
  }, []);

  const upImg = (key, file, img) => {
    console.log("upImg：", key, file, img);

    store.editStore.uploading = true;
    Storage.put(key, file, {})
      .then((res) => {
        console.log("upload file res", res);
        store.editStore.setFileList([
          {
            path: `public/${key}`,
            url: `https://${process.env.REACT_APP_CLOUDFRONT}.cloudfront.net/public/${key}`,
            imageHeight: img.naturalHeight,
            imageWidth: img.naturalWidth,
            imageSize: formatBytes(file.size),
          },
        ]);
      })
      .catch((err) => {
        console.log("Error uploading file: ", err);
      })
      .finally(() => (store.editStore.uploading = false));
  };

  const beforeUpload = (file) => {
    const index = file.name.lastIndexOf(".");
    const ext = file.name.substr(index + 1);
    const key = `${v4()}.${ext.toLowerCase()}`;

    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => {
      const img: any = document.createElement("img");
      img.src = reader.result;
      img.onload = () => {
        if (file.size > 2 * 1024 * 1024) {
          let canvas = document.createElement("canvas");
          let context = canvas.getContext("2d");
          if (context) {
            let rate = 0.2;
            const fileSizeKB = Math.floor(file.size / 1024);
            console.log("file size：", fileSizeKB, "kb");

            rate = Math.floor((3072 / fileSizeKB) * 10) / 30;
            let targetW = (canvas.width = img.width * rate);
            let targetH = (canvas.height = img.height * rate);
            context.clearRect(0, 0, targetW, targetH);
            context.drawImage(img, 0, 0, targetW, targetH);

            console.log("rate", rate);
            canvas.toBlob(
              (blob) => {
                if (blob) {
                  let imgFile = new File([blob], file.name, { type: file.type });
                  upImg(key, imgFile, img);
                }
              },
              file.type,
              1
            );
          } else {
            upImg(key, file, img);
          }
        } else {
          upImg(key, file, img);
        }
      };
    };

    return false;
  };

  const onPreview = async (file) => {
    let src = file.url;
    if (!src) {
      src = await new Promise((resolve) => {
        const reader = new FileReader();
        reader.readAsDataURL(file.originFileObj);
        reader.onload = () => resolve(reader.result);
      });
    }
    const image = new Image();
    image.src = src;
    const imgWindow = window.open(src);
    imgWindow?.document.write(image.outerHTML);
  };

  const ok = () => {
    form.validateFields().then((values) => {
      console.log("values", values, store.editStore.fileList);
      const communities = store.editStore.findCommunities(values.communityIds);
      if (communities.length === 0) {
        notification.error({ message: "Can not get the selected communities" });
        return;
      }
      const pic =
        store.editStore.fileList.length > 0
          ? store.editStore.fileList.map(({ path, imageWidth, imageHeight, imageSize }) => ({
              imageUrl: path,
              imageWidth,
              imageHeight,
              imageSize,
            }))[0]
          : undefined;
      store.editStore.save({
        ...values,
        pic,
      });
    });
  };

  useEffect(() => {
    console.log("useEffect");
    if (store.editStore.model) {
      form.setFieldsValue(store.editStore.model);
      // setFileList(
      //   (store.editStore.model.images || []).map((img) => ({
      //     path: img.url,
      //     url: `https://${process.env.REACT_APP_CLOUDFRONT}.cloudfront.net/${img.url}`,
      //     imageWidth: img.imageWidth,
      //     imageHeight: img.imageHeight,
      //     imageSize: img.imageSize,
      //   }))
      // );
    }
  }, [store.editStore.model]);

  return (
    <Modal
      title="Volunteer"
      visible={true}
      confirmLoading={store.editStore.saving}
      maskClosable={false}
      onOk={ok}
      onCancel={() => store.editStore.close()}
      width="60%"
    >
      {/* <div className="text-3xl font-bold underline">{store.editStore.flexible2}</div> */}
      <Form
        form={form}
        labelCol={{ span: 6 }}
        initialValues={{
          options: [{}],
          customizedChoice: false,
          schedule: [],
          communityIds: [],
          manager: [],
          categories: [],
          needConfirmation: false,
        }}
        wrapperCol={{ span: 18 }}
      >
        <Row>
          <Col span={6}>
            <div style={{ textAlign: "right", paddingRight: 16 }}>Project Host: </div>
          </Col>
          <Col span={18}>
            <div>
              <Row gutter={4}>
                <Col span={8}>
                  <Form.Item name={["host", "name"]}>
                    <Input placeholder="Project host name" />
                  </Form.Item>
                </Col>
                <Col span={16}>
                  <Form.Item name={["host", "website"]}>
                    <Input placeholder="Website" />
                  </Form.Item>
                </Col>
              </Row>
              <Row>
                <Col span={8}>
                  <Form.Item name={["host", "contact"]}>
                    <Input placeholder="Contact person" />
                  </Form.Item>
                </Col>
                <Col span={8}>
                  <Form.Item name={["host", "email"]} rules={[{ type: "email", message: "Invalid email" }]}>
                    <Input placeholder="Email address" />
                  </Form.Item>
                </Col>
                <Col span={8}>
                  <Form.Item name={["host", "phone"]}>
                    <Input placeholder="Phone number" />
                  </Form.Item>
                </Col>
              </Row>
              <Form.Item name={["host", "other"]}>
                <Input.TextArea showCount autoSize={{ minRows: 6 }} placeholder="Other information about the event." />
              </Form.Item>
            </div>
          </Col>
        </Row>

        <Form.Item
          label="Manager"
          name="manager"
          rules={[
            () => ({
              validator(_, value) {
                const errItems = value.filter((v) => !isEmail(v));
                if (errItems.length > 0) {
                  return Promise.reject(new Error("Invalid email"));
                }
                return Promise.resolve();
              },
            }),
          ]}
        >
          <Select
            mode="tags"
            style={{ width: "100%" }}
            // onChange={handleChange}
            tokenSeparators={[","]}
            options={[]}
            placeholder="If not input ,the default is the email address of the current user."
          />
        </Form.Item>

        <Form.Item label="Title" name="title" rules={[{ required: true, message: "Please input title" }]}>
          <Input maxLength={100} placeholder="Enter title" />
        </Form.Item>

        <Form.Item
          label="Description"
          name="description"
          rules={[{ required: true, message: "Please input description" }]}
        >
          <Input.TextArea maxLength={750} showCount autoSize={{ minRows: 6 }} placeholder="Enter description" />
        </Form.Item>

        <Form.Item label="Categories" name="categories">
          <Select
            mode="multiple"
            style={{ width: "100%" }}
            allowClear
            options={Categories.map((c) => ({ label: c, value: c }))}
          />
        </Form.Item>

        <Form.Item label="Requirement" name="requirement">
          <Input.TextArea showCount autoSize={{ minRows: 6 }} placeholder="Enter requirement" />
        </Form.Item>

        <Form.Item
          label="Participation Detail"
          name="participationDetail"
          // rules={[{ required: true, message: "Please input participation detail" }]}
        >
          <Input.TextArea
            maxLength={750}
            showCount
            autoSize={{ minRows: 6 }}
            placeholder="Enter participation detail"
          />
        </Form.Item>

        <Form.Item label="Mode">
          <Radio.Group value={store.editStore.mode} onChange={(e) => (store.editStore.mode = e.target.value)}>
            <Radio.Button value="Dates">Dates Mode</Radio.Button>
            <Radio.Button value="Deadline">Deadline Mode</Radio.Button>
          </Radio.Group>
        </Form.Item>

        {store.editStore.mode == "Deadline" && (
          <>
            <Form.Item
              label="Deadline"
              name="deadline"
              rules={[
                {
                  required: true,
                  message: "Please select deadline",
                },
              ]}
            >
              <DatePicker />
            </Form.Item>
            <Form.Item
              label="Max Number of Hours"
              name="maxHours"
              rules={[
                {
                  required: true,
                  message: "Please input max number of hours",
                },
              ]}
            >
              <InputNumber step={0.1} min={0.1} precision={1}></InputNumber>
            </Form.Item>
          </>
        )}
        {store.editStore.mode == "Dates" && (
          <>
            <Form.Item
              label="Dates"
              name="schedule"
              rules={[{ required: true, type: "array", message: "Please select dates" }]}
            >
              <MultipleDatePicker />
            </Form.Item>
            <Form.Item label="Flexible Time" name="customizedChoice" valuePropName="checked">
              <Checkbox
                onChange={(e) => {
                  if (e.target.checked) {
                    const options = form.getFieldValue("options") || [];
                    if (options.length > 1) {
                      form.setFieldsValue({ options: [options[0]] });
                    }
                  }
                  store.editStore.setFlexible(e.target.checked);
                }}
              ></Checkbox>
            </Form.Item>

            <Form.Item
              label="Available Time"
              name="options"
              dependencies={["schedule"]}
              rules={[
                { required: true, type: "array", min: 1, message: "Please input options" },
                ({ getFieldValue }) => ({
                  validator(_, value) {
                    const errItems = value.filter((v) => !v.name?.trim() || !v.startTime || !v.endTime);
                    if (errItems.length > 0) {
                      return Promise.reject(new Error("Invalid available time"));
                    }

                    const err2 = value.filter((v) => v.endTime.localeCompare(v.startTime) <= 0);
                    if (err2.length > 0) {
                      return Promise.reject(new Error("The start time needs to be later than end time"));
                    }

                    return Promise.resolve();
                  },
                }),
              ]}
            >
              <VolunteerOptions flexible={store.editStore.flexible} />
            </Form.Item>
          </>
        )}
        <Form.Item
          label="Community"
          name="communityIds"
          rules={[{ required: true, message: "Please select community" }]}
        >
          <TreeSelect placeholder="Select Community" treeData={store.editStore.regionTree} treeCheckable />
        </Form.Item>

        <Form.Item label="Location" name="location">
          <GooglePlacePicker />
        </Form.Item>

        <Form.Item
          label="Display Address"
          name="displayAddress"
          dependencies={["location"]}
          rules={[
            ({ getFieldValue }) => ({
              required: !!getFieldValue("location"),
              message: "Please enter display address",
            }),
          ]}
        >
          <Input maxLength={100} placeholder="Enter Display Address" />
        </Form.Item>

        <Form.Item label="Image">
          <Upload
            accept="image/*"
            listType="picture-card"
            fileList={store.editStore.fileList}
            onPreview={onPreview}
            beforeUpload={beforeUpload}
            onRemove={() => store.editStore.setFileList([])}
            disabled={store.editStore.uploading}
          >
            {store.editStore.fileList.length >= 1 ? null : (
              <div>{store.editStore.uploading ? <Spin /> : "+ Upload"}</div>
            )}
          </Upload>
        </Form.Item>
        <Form.Item label="Confirmation" name="needConfirmation" valuePropName="checked">
          <Checkbox></Checkbox>
        </Form.Item>

        <Form.Item label="Questions" name="questions">
          <ListInput max={5} />
        </Form.Item>
      </Form>
    </Modal>
  );
});
